export default __webpack_public_path__ + "static/SRI 4400HV - Product Specifications & Technical Data-e16d9d83472310e3b0fd34fca936a04a.pdf";